import { authorizedRequest, logout } from "./account";
import { responseError } from "./errors";

require("dotenv").config();

const ENV = process.env;

export const REQUEST_DST_EXTRA_RULES = "REQUEST_DST_EXTRA_RULES";
export const RECEIVE_DST_EXTRA_RULES = "RECEIVE_DST_EXTRA_RULES";
export const RECEIVE_DST_EXTRA_RULE = "RECEIVE_DST_EXTRA_RULE";
const ENDPOINT_PATH = "dst-extra-rules";

export const requestDstExtraRules = () => ({
  type: REQUEST_DST_EXTRA_RULES,
});

export const receivedDstExtraRules = (json) => ({
  type: RECEIVE_DST_EXTRA_RULES,
  json,
});

export const receivedDstExtraRule = (json) => ({
  type: RECEIVE_DST_EXTRA_RULE,
  json,
});

export const createDstExtraRule = (params) => (dispatch) => {
  dispatch(requestDstExtraRules());
  const headers = {};
  headers["Content-Type"] = "application/json";
  return authorizedRequest(`${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}`, {
    method: "POST",
    headers,
    body: JSON.stringify(params),
  })
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};

export const deleteDstExtraRule = (id) => (dispatch) => {
  dispatch(requestDstExtraRules());
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "DELETE", headers: {} },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};

export const fetchDstExtraRules = (sort) => (dispatch) => {
  dispatch(requestDstExtraRules());
  let url = `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}`;
  if (sort) url += `?order=${JSON.stringify(sort)}`;
  return authorizedRequest(url, { method: "GET" })
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
        dispatch(receivedDstExtraRules([]));
      } else if (json.status === 401) {
        dispatch(logout());
        dispatch(receivedDstExtraRules([]));
      } else {
        dispatch(receivedDstExtraRules({ data: json } || []));
      }
      return json;
    });
};

export const fetchDstExtraRule = (id) => (dispatch) => {
  dispatch(requestDstExtraRules());
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "GET" },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(logout());
      } else {
        dispatch(receivedDstExtraRule(json));
      }
      return json;
    });
};

export const saveDstExtraRule = (id, params) => (dispatch) => {
  dispatch(requestDstExtraRules());
  const headers = {};
  headers["Content-Type"] = "application/json";
  return authorizedRequest(
    `${ENV.REACT_APP_API_SERVER}/${ENDPOINT_PATH}/${id}`,
    { method: "POST", headers, body: JSON.stringify(params) },
  )
    .then(
      (response) => (response.status === 200 ? response.json() : response),
      (error) => error,
    )
    .then((json) => {
      if (String(json).includes("TypeError")) {
        dispatch(responseError("Problems with server"));
      } else if (json.status === 401) {
        dispatch(responseError("Unauthorized"));
      }
      return json;
    });
};
